import { addDays, weekday, type IsoDate } from "../dates";
import type { Meal, MealSlot, MealSlotsPreset, WeekStart } from "./models";

/** First day of the week containing `date`. */
export function weekStartOf(date: IsoDate, start: WeekStart): IsoDate {
  const dow = weekday(date); // 0 = Sunday
  const back = start === "sunday" ? dow : (dow + 6) % 7;
  return addDays(date, -back);
}

export function weekDates(first: IsoDate): IsoDate[] {
  return Array.from({ length: 7 }, (_, i) => addDays(first, i));
}

export function slotsFor(preset: MealSlotsPreset): MealSlot[] {
  return preset === "all" ? ["breakfast", "lunch", "dinner"] : ["dinner"];
}

export const SLOT_LABEL: Record<MealSlot, string> = { breakfast: "Breakfast", lunch: "Lunch", dinner: "Dinner" };

export function mealKey(date: IsoDate, slot: MealSlot): string {
  return `${date}|${slot}`;
}

export function indexMeals(meals: Meal[]): Map<string, Meal> {
  return new Map(meals.map((m) => [mealKey(m.date, m.slot), m]));
}

/**
 * The meal a "tonight" card should feature at a given local time: the next
 * planned meal today among the shown slots (breakfast until 10:30, lunch
 * until 14:30, then dinner), falling back to dinner.
 */
export function featuredSlot(minutesAfterMidnight: number, slots: MealSlot[]): MealSlot {
  const order: { slot: MealSlot; until: number }[] = [
    { slot: "breakfast", until: 10 * 60 + 30 },
    { slot: "lunch", until: 14 * 60 + 30 },
    { slot: "dinner", until: 24 * 60 },
  ];
  for (const o of order) if (slots.includes(o.slot) && minutesAfterMidnight < o.until) return o.slot;
  return "dinner";
}
